import * as React from 'react';
import './HeaderMenuItemSeparator.scss.js';

const HeaderMenuItemSeparator = () => /* @__PURE__ */ React.createElement("div", {
  className: "vai-header-menu-item-separator"
});

export { HeaderMenuItemSeparator };
